import { FuelPricesMode, Location, StoreLocationsQuery } from '@ocx/graphql';
import { Coordinates, IStore, PriceType } from './types';
import { calculateDistance } from '../../lib/geolocation/utils/calculateDistance';
import { getDirectionLink } from '../../lib/geolocation/utils/getDirectionLink';
import { buildAddressLine2 } from '../../lib/store/addressLine';
import { mapFuelGradeGroups } from './mapFuelGrades';
import { FuelGradesConfiguration } from '../configuration/app-config.types';

export const getLocationNodes = (storesData?: StoreLocationsQuery): Location[] => {
  if (!storesData?.stores?.edges?.length) {
    return [];
  }
  // @ts-ignore TODO remove when when schema be fixed
  return storesData.stores.edges.map((edge) => edge.node).filter((node) => node?.address?.geoLocation);
};

export const mapLocationsData = (
  nodes: Location[],
  targetLocation: Coordinates,
  currentLocation: Coordinates,
  formatPrice: (price: number) => string,
  config: FuelGradesConfiguration,
  fuelPricesMode: FuelPricesMode,
  priceTypeTitles: Record<PriceType, string>,
): IStore[] => {
  const list: IStore[] = [];
  nodes.forEach((node) => {
    if (!node.address?.geoLocation) {
      return;
    }
    const { latitude: lat, longitude: lng } = node.address.geoLocation;

    const priceGroups = mapFuelGradeGroups({
      grades: node.fuelGradePrices,
      config,
      formatPrice,
      fuelPricesMode,
      priceTypeTitles,
    });

    const distance = calculateDistance(currentLocation, { lat, lng });
    const searchDistance = calculateDistance(targetLocation, { lat, lng });

    const { street1, city, state } = node.address;
    list.push({
      id: node.uuid,
      distance,
      searchDistance,
      directionLink: getDirectionLink(currentLocation, { lat, lng }),
      price: priceGroups[0]?.prices.find((price) => price.isDefault)?.price || null,
      priceGroups,
      addressLine1: street1,
      addressLine2: buildAddressLine2({ city, state }),
      lat,
      lng,
      location: node,
    });
  });
  return list;
};
